import { AppBar, styled, Toolbar, Typography, Box } from '@mui/material';

export const HEADER_HEIGHT = '6.4rem';

export const AppBarStyled = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  boxShadow: theme.customShadow,
  height: HEADER_HEIGHT,
  display: 'flex',
  padding: 0,
  zIndex: 1030,
}));

export const ToolbarStyled = styled(Toolbar)(({ theme }) => ({
  padding: 0,
  height: '100%',
  paddingLeft: '32px',
  paddingRight: '32px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    paddingLeft: '24px',
    paddingRight: '24px',
  },
}));

export const MobileAndTabletChatBotStyling = styled('div')(({ theme }) => ({
  marginTop: 'auto',
  marginBottom: 'auto',
  [theme.breakpoints.up('lg')]: {
    display: 'none',
  },
}));

export const LogoWrapperStyled = styled(Box)({
  height: '100%',
  maxHeight: '36px',
  marginRight: '8px',
});

export const DrawerVisibleStyled = styled(Box)(({ theme }) => ({
  padding: 10,
  marginRight: '-10px', // preserving the width for the purposes of WCAG but aligning it properly against the right edge
  [theme.breakpoints.up('lg')]: {
    display: 'none',
  },
}));

export const HeaderWrapperStyled = styled(Box)({
  display: 'flex',
  height: HEADER_HEIGHT,
  flexGrow: 1,
});

export const NameStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.black,
  textTransform: 'capitalize',
  marginLeft: 'auto',
  paddingRight: '14px',
  marginTop: 'auto',
  marginBottom: 'auto',

  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const Offset = styled('div')(({ theme }) => theme.mixins.toolbar);
